// src/components/Management.js
import React, { useState } from "react";
import Fooduserorders from "./Fooduserorders"; // Adjust path if necessary
import Foodvendororders from "./Foodvendororders"; // Adjust path if necessary
import { Link } from 'react-router-dom';
import "./fooduserorders.css";
function Foodorder() {
    const [activeView, setActiveView] = useState("user");

    // Original margin for the container-fluid, potentially for a global page header or spacing.
    const pageWrapperMarginTopString = "35px";

    const contentEffectiveStartOffsetString = "80px"; // Using the original `topOffset` value

    const internalMarginTopValue =
        parseFloat(contentEffectiveStartOffsetString) - parseFloat(pageWrapperMarginTopString);
    const internalMarginTop = `${internalMarginTopValue}px`; // e.g., "45px"

    // The height for the main flex container (which holds the button bar and scrollable content).
    // It should fill the remaining viewport height after accounting for contentEffectiveStartOffset.
    const mainFlexContainerHeight = `calc(100vh - ${contentEffectiveStartOffsetString})`;



    return (
        <div className="container-fluid p-0" style={{ marginTop: '5px' }}>
            <div className="row">
                <div className="col-lg-2"></div> {/* Sidebar or empty space */}
                <div className="col-lg-10 col-md-12 col-sm-12 col-12 or7">

                    <p
                        className="breadcrumb maamaas-home-bredcum or7"
                        style={{
                            position: "fixed",
                            top: "39px",
                            left: "0vw",

                            width: "auto",          // 👈 full width removed
                            maxWidth: "70%",        // 👈 right side space free
                            display: "inline-block",

                            padding: "30px 20px",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "left",
                            margin: 0,
                            height: "70px",

                            zIndex: "9999",
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>
                        <span style={{ color: "purple", fontWeight: "bold" }}>
                            <Link

                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Order_Management
                            </Link>
                        </span>  <span className="separator"> &gt; </span>
                        <span style={{ color: "purple", fontWeight: "bold" }}>
                            <Link

                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >

                                Food & Beverages
                            </Link>
                        </span>
                    </p>

                    <div
                        style={{

                            marginTop: internalMarginTop, // Positions this block correctly within col-lg-10
                            height: mainFlexContainerHeight, // Ensures it fits the desired viewport portion
                        }}
                    >
                        {/* Button Bar Container */}
                        <div
                            className="d-flex justify-content-center row g-2" // Bootstrap class for centering buttons
                            style={{
                                // padding: "1rem 0", // Adds vertical spacing around the buttons
                                backgroundColor: "#ffffff", // Crucial for sticky; content won't show through
                                flexShrink: 0, // Prevents this bar from shrinking if content is sparse
                                position: "sticky",
                                top: 0, // Sticks to the top of its parent (the Main Flex Container)
                                zIndex: 10, // Ensures it stays above scrolling content
                                gap: "10px",
                                // borderBottom: '1px solid #e0e0e0', // Optional: if a visual separator is desired
                            }}
                        >

                        </div>

                        {/* Scrollable Content Area */}
                        <div
                            style={{
                                flexGrow: 1,
                            }}
                            className="orders-food-mobile-view"
                        >
                            {activeView === "user" && <Fooduserorders />}
                            {activeView === "vendor" && <Foodvendororders />}
                            {/* {activeView === "delivery" && <Deliveryorders />} */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Foodorder;